var map = {
	"./ace_of_wands.png": 988,
	"./eight_of_wands.png": 989,
	"./five_of_wands.png": 990,
	"./four_of_wands.png": 991,
	"./king_of_wands.png": 992,
	"./knight_of_wands.png": 993,
	"./nine_of_wands.png": 994,
	"./page_of_wands.png": 995,
	"./queen_of_wands.png": 996,
	"./seven_of_wands.png": 997,
	"./six_of_wands.png": 998,
	"./ten_of_wands.png": 999,
	"./three_of_wands.png": 1000,
	"./two_of_wands.png": 1001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 987;